import moment from 'moment';
import { withHost } from 'utils';

export const Api = {
  FetchSalesReport: (fromDate, toDate) => {
    const params = new URLSearchParams();
    params.set('FromDate', moment(fromDate).format('YYYY-MM-DD'));
    params.set('ToDate', moment(toDate).format('YYYY-MM-DD'));
    params.set('Granularity', 'DAILY');

    return withHost(`/reports/artist_sales?${params.toString()}`);
  },
};
